import application_settings from '../applicationSettings';
import Event from './Event';

class OrderCancellationRequest extends Event {
    eventName = 'oms_orderCancellationRequest';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Order Cancellation Request
     * 
     * @param {string} data.order_id - order id
     * @param {string} data.reason - reason
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        let cancellationKey = data.cancellation_key;
        let reason = data.reason;


        if (cancellationKey && reason) {
          // request data
          data.endPoint = application_settings.endPoints.orderCancellationRequest;
          data.method = 'POST';
          data.data = {
              client_id: clientId,
              cancellation_key: cancellationKey,
              reason: reason
          };
          
          // send request
          this.sendRequest(data, function (response) {
            if (response) {
              //format response data
              let data = thisObj.formatResponseData(response);

              //fire success event
              thisObj.onSuccessEvent(data, {
                action: action,
                request_id: requestId,
              });
            }
          });

        } else {
            //fire error event
            thisObj.onErrorEvent({ "message": "cancellationKey & reason fields are required", "status": 422 });
        }
    }


}

export default OrderCancellationRequest;